export default "__VITE_ASSET__5699b79b__"